import { memo } from 'react';

import { Settings } from '@mint-lib/icons';
import { Badge } from '@mint-lib/tw-components';

type PlatformIconType = {
  logo: string | null;
  counter: number | undefined;
};

const PlatformIcon = ({ logo, counter }: PlatformIconType) => {
  return (
    <div className="relative flex h-8 w-8">
      <Badge
        content={counter}
        invisible={!counter}
        color="secondary"
        variant="standard"
      >
        {logo ? (
          <img className="h-8 w-8" src={logo} alt="Platform logo" />
        ) : (
          <Settings className="h-8 w-8" />
        )}
      </Badge>
    </div>
  );
};

export default memo(PlatformIcon);
